import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import cooTranslationsDE from "../translation/german/cco_translations_de.json";


//---Using translation
const resources = {
    de: {
        translation: cooTranslationsDE
    }
}

//---Using different namespaces
//https://www.i18next.com/principles/namespaces
// const resources = {
//     en: {
//         home: translationEnglish,
//         main: translationEnglishSecondFile,
//     },
//     de: {
//         home: translationSpanish,
//     }
//
// }

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng:"de", //default language
    });

export default i18next;